// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeIndicatorsPage_wrapper__gRCpE"};